import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Tooltip,
  Button,
  Icon,
  Pagination,
  Upload,
  message,
  Modal,
  Switch,
} from "antd";
import { useTranslation } from "react-i18next";
import api from "../../../../../services/apiInstance";
import { truncateText } from "../../../../../services/utils";
import {
  uploadContent,
  convertImage,
  aspectRatiosMatch,
} from "../../../../../services/contents";
import { makeApiCall } from "../../../../../services/apiErrorHandlers";
import useBreakpoint from "../../../../../hooks/useBreackpoint";
import canvaLogo from "../../../../../images/canva-icon.png";
import FolderSelect from "../../../../shared/components/FolderSelect";
import SearchInput from "../../../../shared/components/SearchInput";
import GenerateSkeletonComponent from "../../../../shared/components/GenerateSkeletonComponent";
import ModalContentComponent from "../../../../shared/components/ModalContentComponent";
import OptionModal from "../../../../shared/components/OptionModal";
import AlertChangeAdModalComponent from "../../../../shared/components/AlertChangeAdModalComponent";
import CanvaContainer from "../../../../shared/containers/CanvaContainer";
import ChangeAdModalHolder from "../../styles/changeAdModalStyle";

import Colors from '../../../../../themes/Colors';
const ChangeAdModal = (props) => {
  const { t } = useTranslation();
  const {
    user,
    getContentsByCompany,
    getContentsByUsers,
    setLibraryContents,
    libraryContents,
    loadingContentsbyCompany,
    token,
    updateDefaultContentRequest,
    defaultContent,
    brand,
    relation,
    updateRelationCampaignRequest,
    updateContentDisplayByContent,
    currentCampaign,
    exitModal,
    statusNewContent,
    setStatusNewContent,
    changeProgrammaticContentRequest,
    getCampaign,
    fileCanvaNew,
    visible,
  } = props;

  const defaultTag = { id: null, key: null, label: "Todos", name: t("All") };
  const [pageContents, setPageContents] = useState(1);
  const [totalContent, setTotalContent] = useState(0);
  const [lengthPage, setLengthPage] = useState(7);
  const [tagsContents, setTagsContents] = useState([]);
  const [selectTagContent, setSelectTagContent] = useState(null);
  const [visibleModalContent, setVisibleModalContent] = useState(false);
  const [contentModal, setContentModal] = useState(null);
  const [visibleModalDeleteContent, setVisibleModalDeleteContent] = useState(false);
  const [loading, setLoading] = useState(false);
  const breakpoint = useBreakpoint();
  const [visibleCanvaModal, setVisibleCanvaModal] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedContents, setSelectedContents] = useState({});
  const [expandAd, setExpandAd] = useState(false);
  const [assignRule, setAssignRule] = useState(false);
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [alertModalType, setAlertModalType] = useState(null);

  const uploadProps = uploadContent(
    t,
    message,
    token,
    setStatusNewContent,
    setLoading,
    selectTagContent
  );

  const uploadButton = (
    <Card
      className="contentCardContent"
      style={{
        backgroundColor: Colors.surfaceMuted,
        width: "134px",
        minHeight: "200px",
        padding: "12px 12px 8px 12px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "7px",
        borderRadius: "4px",
      }}
    >
      <Button
        shape="circle"
        className="icon-card cardUpload icon-size"
        icon={loading ? "loading" : "cloud-upload"}
      >
        <span
          style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}
        >
          {!selectTagContent || !selectTagContent.key ? (
            <p
              className="textCard centerCard"
              style={{ color: "red", textAlign: "center", fontSize: "11px" }}
            >
              {t("Upload message 1")} <br />
              {t("Upload message 2")} <br />
              {t("Upload message 3")} <br />
            </p>
          ) : (
            <p
              className="textCard centerCard"
              style={{ textAlign: "center", fontSize: "12px" }}
            >
              {t("Upload")} <br />
              {t("Upload continue")} <br />
              {t("Upload continue 2")}
            </p>
          )}
        </span>
      </Button>
    </Card>
  );

  const checkReadyContent = (id) => {
    updateDefaultContentRequest(id);
  };

  const changePageContents = (page) => {
    setPageContents(page);
    getLibraryContents(page, selectTagContent);
  };

  const onChangeFolder = (value) => {
    value.key = value.key === "null" ? null : value.key;
    setSelectTagContent(value);
  };

  const onSearch = (e) => {
    setPageContents(1);
    setSearch(e.target.value);
  };

  const getSearchParams = () => {
    let width = "";
    let height = "";
    const regex = /(\d+)\s*x\s*(\d+)/;
    const match = search.match(regex);
    if (match) {
      width = match[1];
      height = match[2];
    }
    return {
      search: { value: !match ? search : null, regex: false },
      columns: [
        {
          data: !match ? "name" : null,
          searchable: true,
          orderable: false,
          search: { value: "", regex: false },
        },
        {
          data: "width",
          searchable: true,
          orderable: false,
          search: { value: match ? width : "", regex: false },
        },
        {
          data: "height",
          searchable: true,
          orderable: false,
          search: { value: match ? height : "", regex: false },
        },
      ],
    };
  };

  const getLibraryContents = (page, tagFolder = null) => {
    if (tagsContents.length === 0) return;
    const tag = tagFolder ? tagFolder.key : selectTagContent.key;
    const startPage = (page - 1) * lengthPage;
    let params = {
      start: startPage,
      length: lengthPage,
      page,
      draw: 1,
      datatable: true,
      origin: "dsp",
    };
    if (tag) params.tag = tag;
    if (search) params = { ...params, ...getSearchParams() };
    if (user.company) {
      getContentsByCompany(user.company.id, params);
    } else {
      getContentsByUsers(user.id, params);
    }
  };

  const translateTagName = (name) => {
    if (name === "Por defecto") return t("default");
    if (/^Default user \(\d+\)$/.test(name)) return t("my_content");
    return name;
  };

  const fetchTagsContent = async () => {
    try {
      const response = await makeApiCall(api.getTagsContents, user.company.id);
      setTagsContents(
        response.data.map((tag) => ({ ...tag, name: translateTagName(tag.name) }))
      );
    } catch (error) {
      message.error(error.message);
    }
  };

  const fetchTagsContentForUser = async () => {
    try {
      const response = await makeApiCall(api.getTagsContentsByUser, user.id);
      setTagsContents(
        response.data.map((tag) => ({ ...tag, name: translateTagName(tag.name) }))
      );
    } catch (error) {
      message.error(error.message);
    }
  };

  const updateContent = async () => {
    try {
      await makeApiCall(api.updateContent, contentModal.id, { archived: true });
      setVisibleModalDeleteContent(false);
      getLibraryContents(pageContents, selectTagContent);
    } catch (error) {
      message.error(error.message);
      setVisibleModalDeleteContent(false);
    }
  };

  const showModalContent = (content) => {
    if (!content) return;
    setContentModal(content);
    setVisibleModalContent(true);
  };

  const cancelModalContent = () => {
    setContentModal(null);
    setVisibleModalContent(false);
  };

  const showModalDeleteContent = (value = false, content) => {
    setContentModal(content);
    setVisibleModalDeleteContent(value);
  };

  const calculateLengthPage = () => {
    if (breakpoint === "xs" || breakpoint === "sm" || breakpoint === "md")
      return setLengthPage(2);
    if (breakpoint === "lg") return setLengthPage(3);
    if (breakpoint === "xl") return setLengthPage(5);
    return setLengthPage(7);
  };

  const setReadyContent = () => {
    const copyStatusNewContent = {
      ...statusNewContent,
      fileList: [...statusNewContent.fileList.slice(1)],
    };
    if (statusNewContent.fileList.length === 1) {
      const copyLibraryContents = {
        ...libraryContents,
        data: libraryContents.data ? [...libraryContents.data] : [],
      };
      copyLibraryContents.data[0] = defaultContent;
      setLibraryContents(copyLibraryContents);
    }
    setStatusNewContent(copyStatusNewContent);
    setLoading(false);
  };

  const isOwnerDefaultContent = (tag) => {
    const companyOwnerOfDefaultContent = 757;
    const companyId = user.company ? user.company.id : null;
    if (tag && tag.key === "1" && companyId !== companyOwnerOfDefaultContent)
      return false;
    return true;
  };

  const addContentsFromInfoCampaign = (contentId, screenRelation) => {
    updateRelationCampaignRequest(contentId, screenRelation, currentCampaign.id);
    const fullContent = libraryContents.data.find(
      (c) => c.id === Number(contentId)
    );
    if (fullContent) {
      const existingVersionNames = new Set(
        currentCampaign.contents_displays.map((cc) => cc.content_version_name || "V1")
      );
      const numbers = [...existingVersionNames]
        .map((v) => {
          const match = /^V(\d+)$/i.exec(v);
          return match ? parseInt(match[1], 10) : NaN;
        })
        .filter((n) => !isNaN(n));
      let nextNumber = (numbers.length ? Math.max(...numbers) : 1) + 1;
      while (existingVersionNames.has(`V${nextNumber}`)) nextNumber += 1;
      const nextVersion = `V${nextNumber}`;
      const newContentForDisplay = {
        content_file: fullContent.file,
        content_file_thumb: fullContent.file_thumb,
        content_height: fullContent.height,
        content_id: fullContent.id,
        content_name: fullContent.name,
        content_type: fullContent.type,
        content_width: fullContent.width,
        content_version_name: nextVersion,
      };
      updateContentDisplayByContent(newContentForDisplay, screenRelation);
    }
  };

  const handleChangeAd = () => {
    const selectedId = Object.keys(selectedContents).find(
      (id) => selectedContents[id]
    );
    const content = libraryContents.data.find((c) => c.id === Number(selectedId));
    if (!selectedId || !content || !relation) {
      setAlertModalVisible(false);
      return;
    }
    if (
      currentCampaign &&
      (currentCampaign.payment_status === "pending" ||
        currentCampaign.payment_status === "pre_approved")
    ) {
      addContentsFromInfoCampaign(selectedId, relation);
      setAlertModalVisible(false);
      exitModal();
      return;
    }
    if (alertModalType === "change") {
      const params = {
        content_display_id: Number(relation.id),
        display_id: Number(relation.display_id),
        content_id: Number(content.id),
        type: "complete_and_create_new_relation",
        white_label_name: "latinad",
        fill_content: Boolean(expandAd),
        replicate_rules: Boolean(assignRule),
      };
      changeProgrammaticContentRequest(currentCampaign.id, params);
    } else if (alertModalType === "add") {
      const activeContents = currentCampaign.contents_displays.filter(
        (cd) =>
          cd.display_id === relation.display_id &&
          cd.revision_status !== "inactive"
      );
      const totalPromisedShows = activeContents.reduce(
        (sum, cd) => sum + cd.promised_shows,
        0
      );
      const newPromisedShows = Math.floor(
        totalPromisedShows / (activeContents.length + 1)
      );
      const existingVersionNames = new Set(
        currentCampaign.contents_displays.map((cd) => cd.content_version_name || "V1")
      );
      const versions = [...existingVersionNames]
        .map((v) => {
          const match = /^V(\d+)$/i.exec(v);
          return match ? parseInt(match[1], 10) : NaN;
        })
        .filter((n) => !isNaN(n));
      let nextNumber = Math.max(...versions, 0) + 1;
      while (existingVersionNames.has(`V${nextNumber}`)) nextNumber += 1;
      const newVersion = `V${nextNumber}`;
      let rules = [];
      if (assignRule && activeContents.length > 0) {
        const contentWithRules = activeContents.find(
          (cd) => cd.rules && cd.rules.length > 0
        );
        if (contentWithRules) rules = contentWithRules.rules;
      }
      const contents_displays = [
        ...activeContents.map((cd) => ({
          ...cd,
          promised_shows: newPromisedShows,
        })),
        {
          display_id: Number(relation.display_id),
          active: 1,
          content_version_name: newVersion,
          relation_id: null,
          content_id: Number(content.id),
          fill_screen: Boolean(expandAd),
          promised_shows: newPromisedShows,
          rules,
          subsidized_price: false,
          promised_shows_subsidized: 0,
          content_name: content.name,
          revision_status: null,
        },
      ];
      const params = {
        display_id: Number(relation.display_id),
        content_id: Number(content.id),
        contents_displays,
        type: "rebalance_and_create_new_relation",
        white_label_name: "latinad",
        fill_content: Boolean(expandAd),
        replicate_rules: Boolean(assignRule),
      };
      changeProgrammaticContentRequest(currentCampaign.id, params);
    }
    if (currentCampaign && currentCampaign.id) {
      getCampaign(currentCampaign.id);
    }
    exitModal();
    setAlertModalVisible(false);
  };

  const handleFooterButtonChangeClick = (type) => {
    if (
      currentCampaign &&
      (currentCampaign.payment_status === "pending" ||
        currentCampaign.payment_status === "pre_approved")
    ) {
      handleChangeAd();
    } else {
      setAlertModalType(type);
      setAlertModalVisible(true);
    }
  };

  useEffect(() => {
    setLibraryContents([]);
    if (user.company) {
      fetchTagsContent();
    } else {
      fetchTagsContentForUser();
    }
    setStatusNewContent(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let brandTags = defaultTag;
    if (tagsContents && tagsContents.length > 0 && brand) {
      brandTags = tagsContents.find((tag) => tag.brand_id === brand.id) || defaultTag;
    }
    setSelectTagContent({ key: brandTags.id, label: brandTags.name });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tagsContents, brand]);

  useEffect(() => {
    getLibraryContents(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectTagContent]);

  useEffect(() => {
    getLibraryContents(pageContents, selectTagContent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  useEffect(() => {
    if (!lengthPage) return;
    getLibraryContents(pageContents, selectTagContent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lengthPage]);

  useEffect(() => {
    if (!libraryContents || !libraryContents.data) return;
    if (search) return setTotalContent(libraryContents.recordsFiltered);
    setTotalContent(libraryContents.recordsTotal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [libraryContents]);

  useEffect(() => {
    if (!statusNewContent || !statusNewContent.fileList || !statusNewContent.fileList.length)
      return;
    getLibraryContents(1, selectTagContent);
    checkReadyContent(statusNewContent.fileList[0].response.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusNewContent]);

  useEffect(() => {
    if (!fileCanvaNew || !fileCanvaNew.resp || !fileCanvaNew.resp.data) return;
    getLibraryContents(1, selectTagContent);
    checkReadyContent(fileCanvaNew.resp.data.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileCanvaNew]);

  useEffect(() => {
    if (
      !statusNewContent ||
      !statusNewContent.fileList ||
      !statusNewContent.fileList.length
    )
      return;
    if (defaultContent.type !== "video") return;
    const id = statusNewContent.fileList[0].response.id;
    if (defaultContent.id === id && defaultContent.file_thumb !== "pending")
      return setReadyContent();
    checkReadyContent(id);
    setLoading(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultContent]);

  useEffect(() => {
    if (!breakpoint) return;
    calculateLengthPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [breakpoint]);

  const anySelected = Object.values(selectedContents).some(Boolean);

  return (
    <Modal
      title={t("Library of contents")}
      visible={visible}
      onCancel={exitModal}
      width={1500}
      bodyStyle={{ padding: "30px" }}
      transitionName="fade"
      footer={
        <Row type="flex" justify="space-between" align="middle" style={{ width: "100%" }}>
          <Col>
            <span className="footerSwitchLabel">
              {t("Expand ad to fill the screen")}
            </span>
            <Switch
              checked={expandAd}
              onChange={setExpandAd}
              style={{ marginLeft: 12, marginRight: 20 }}
            />
            <span className="footerSwitchLabel">{t("Assign rule")}</span>
            <Switch
              checked={assignRule}
              onChange={setAssignRule}
              style={{ marginLeft: 12 }}
            />
          </Col>
          <Col>
            <div className="footerButtons">
              {currentCampaign && currentCampaign.payment_status !== "pending" && (
                <Button
                  className="footerButtonAdd"
                  onClick={() => {
                    setAlertModalType("add");
                    setAlertModalVisible(true);
                  }}
                  disabled={!anySelected}
                >
                  {t("Add ad")}
                </Button>
              )}
              <Button
                className="footerButtonChange"
                onClick={() => handleFooterButtonChangeClick("change")}
                disabled={!anySelected}
              >
                {t("Change ad")}
              </Button>
            </div>
          </Col>
        </Row>
      }
    >
      <ChangeAdModalHolder
        lengthCard={
          !loadingContentsbyCompany &&
          libraryContents.data &&
          libraryContents.data.length === 0
            ? 300
            : 125
        }
      >
        <Row type="flex" className="contents-library" gutter={40}>
          <Col xs={24} sm={24} md={24} lg={24}>
            <Row type="flex" style={{ gap: 20, flexWrap: "nowrap" }} justify="space-between">
              <Row type="flex" style={{ columnGap: 20 }} align="middle">
                <Col>
                  <Tooltip title={t("Folder advertisement")}>
                    <Icon type="exclamation-circle" style={{ marginRight: "5px" }} />
                  </Tooltip>
                  <span className="selectTag">
                    {t("View contents from the folder")}:
                  </span>
                  <FolderSelect
                    folders={tagsContents}
                    t={t}
                    value={selectTagContent || defaultTag}
                    onChange={onChangeFolder}
                    disabled={!selectTagContent}
                    className="select"
                  />
                </Col>
              </Row>
              <Row type="flex" style={{ columnGap: 20 }} align="middle">
                <Col lg={8}>
                  <SearchInput type="async" onChange={onSearch} />
                </Col>
                <Col lg={8}>
                  <Button
                    disabled={!selectTagContent || !selectTagContent.key}
                    onClick={() => setVisibleCanvaModal(true)}
                  >
                    <img
                      src={canvaLogo}
                      style={{ height: "25px", marginRight: "6px" }}
                      alt=""
                    />{" "}
                    {t("Design spot")}
                  </Button>
                </Col>
              </Row>
            </Row>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} className="libCard">
            <Row className="contentCard" type="flex" justify="center">
              {!libraryContents.data || !selectTagContent ? (
                <GenerateSkeletonComponent
                  count={lengthPage}
                  height={218.3}
                  width={141.3}
                />
              ) : (
                libraryContents.data.map((content, index) => (
                  <Card className="cardContent" key={index}>
                    <span className="textCard">
                      {content.name ? (
                        <Tooltip placement="top" title={content.name}>
                          {truncateText(content.name, 13)}
                        </Tooltip>
                      ) : (
                        <>&nbsp;</>
                      )}
                    </span>
                    <div className="centerCard">
                      {content.file_thumb !== "pending" ? (
                        <img
                          src={convertImage(content.file_thumb)}
                          onClick={() => showModalContent(content)}
                          className="contentCardImage"
                          alt=""
                        />
                      ) : (
                        <GenerateSkeletonComponent count={1} height={70} width={115} />
                      )}
                    </div>
                    <p className="textCard centerCard">
                      {content.width} x {content.height}
                    </p>
                    {(() => {
                      const matchResult = aspectRatiosMatch(
                        content.width,
                        content.height,
                        relation.display_resolution_width,
                        relation.display_resolution_height,
                        currentCampaign.tolerance_resolution
                      );
                      const isSelected = !!selectedContents[content.id];
                      const isDisabled =
                        !matchResult[0] || (anySelected && !isSelected);
                      return (
                        <Tooltip
                          title={
                            matchResult[0]
                              ? t("Add content to the campaign")
                              : t(
                                  "This ad does not fit the screen resolution according to the tolerance set in the campaign"
                                )
                          }
                        >
                          <Button
                            shape="circle"
                            className={
                              matchResult[0]
                                ? "icon-card cardGreen"
                                : "icon-card disabled-style-add-button"
                            }
                            onClick={() =>
                              setSelectedContents((prev) => ({
                                ...prev,
                                [content.id]: !prev[content.id],
                              }))
                            }
                            disabled={isDisabled}
                          >
                            <Icon type={isSelected ? "check" : "plus"} />
                          </Button>
                        </Tooltip>
                      );
                    })()}
                  </Card>
                ))
              )}
              {isOwnerDefaultContent(selectTagContent) && (
                <div
                  className={`contentVideoUpload ${
                    !selectTagContent || !selectTagContent.key
                      ? "disabledVideoUpload"
                      : ""
                  }`}
                >
                  <Upload {...uploadProps} disabled={loading}>
                    {uploadButton}
                  </Upload>
                </div>
              )}
            </Row>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="pagination">
            <Pagination
              current={pageContents}
              pageSize={lengthPage}
              total={totalContent}
              onChange={changePageContents}
            />
          </Col>
        </Row>

        <ModalContentComponent
          visible={visibleModalContent}
          onCancel={cancelModalContent}
          content={contentModal}
        />
        <CanvaContainer
          visible={visibleCanvaModal}
          tag={selectTagContent}
          onClose={() => setVisibleCanvaModal(false)}
        />
        <OptionModal
          title={t("Atention!")}
          body={t(
            "Are you sure you want to delete this ad from the library? You will need to upload it again if you want to use it again."
          )}
          visible={visibleModalDeleteContent}
          okText={t("Delete")}
          cancelText={t("Cancel")}
          onOk={updateContent}
          onCancel={() => showModalDeleteContent(false)}
          okButtonProps={{ loading: true }}
        />
      </ChangeAdModalHolder>
      <AlertChangeAdModalComponent
        visible={alertModalVisible}
        title={
          alertModalType === "add"
            ? t("Do you want to add this ad to the screen?")
            : t("Are you sure you want to change this ad?")
        }
        description={
          alertModalType === "add"
            ? t(
                "Upon confirmation, a new ad will be added as a new version within this screen. The remaining promised spots from other ads will be distributed equally among all active ads on the screen. If you prefer to allocate a specific number of spots to each ad, you can do so from the 'Edit Campaign' option."
              )
            : t(
                "By selecting this option, the promised spots and remaining investment will be transferred to the new ad. The current ad will remain in 'Inactive' status and will retain the history of past spots. You can confirm to continue or cancel if you wish to keep the current ad."
              )
        }
        onAccept={handleChangeAd}
        onCancel={() => setAlertModalVisible(false)}
      />
    </Modal>
  );
};

export default ChangeAdModal;
